import {
    DateCalendar as MaterialDateCalendar,
    DateCalendarProps,
} from '@mui/x-date-pickers';
import { Moment } from 'moment';

export const DateCalendar = (props: DateCalendarProps<Moment>) => {
    return (
        <MaterialDateCalendar
            data-testid={'DateCalendar-container'}
            {...props}
        />
    );
}

export default DateCalendar;
